/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ModifyJobTagLinkRequest from './ModifyJobTagLinkRequest';
import Priority from './Priority';

/**
 * The JobRequest model module.
 * @module model/JobRequest
 * @version V1
 */
class JobRequest {
    /**
     * Constructs a new <code>JobRequest</code>.
     * @alias module:model/JobRequest
     */
    constructor() { 
        
        JobRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>JobRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobRequest} obj Optional instance to populate.
     * @return {module:model/JobRequest} The populated <code>JobRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobRequest();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('priority')) {
                obj['priority'] = Priority.constructFromObject(data['priority']);
            }
            if (data.hasOwnProperty('startDate')) {
                obj['startDate'] = ApiClient.convertToType(data['startDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('assignee')) {
                obj['assignee'] = ApiClient.convertToType(data['assignee'], 'Number');
            }
            if (data.hasOwnProperty('tags')) {
                obj['tags'] = ModifyJobTagLinkRequest.constructFromObject(data['tags']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        // validate the optional field `tags`
        if (data['tags']) { // data not null
          ModifyJobTagLinkRequest.validateJSON(data['tags']);
        }

        return true;
    }


}



/**
 * @member {String} name
 */
JobRequest.prototype['name'] = undefined;

/**
 * @member {String} description
 */
JobRequest.prototype['description'] = undefined;

/**
 * @member {Number} status
 */
JobRequest.prototype['status'] = undefined;

/**
 * @member {module:model/Priority} priority
 */
JobRequest.prototype['priority'] = undefined;

/**
 * @member {Date} startDate
 */
JobRequest.prototype['startDate'] = undefined;

/**
 * @member {Date} endDate
 */
JobRequest.prototype['endDate'] = undefined;

/**
 * @member {Number} assignee
 */
JobRequest.prototype['assignee'] = undefined;

/**
 * @member {module:model/ModifyJobTagLinkRequest} tags
 */
JobRequest.prototype['tags'] = undefined;






export default JobRequest;

